import { Box, Checkbox, Divider, IconButton, Stack, TextField } from '@mui/material';
import { IVariable } from './index';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';

export default function Variable({
    variable,
    updateVariable,
    deleteVariable,
}: {
    variable: IVariable;
    updateVariable: (variable: IVariable) => void;
    deleteVariable: (variable: IVariable) => void;
}) {
    return (
        <>
            <Stack direction={'row'} spacing={1} sx={{ pl: 1, pr: 2 }}>
                <Stack direction={'row'} width={0.5}>
                    <TextField
                        label={''}
                        fullWidth
                        value={variable.name}
                        onChange={(event: any) =>
                            updateVariable({
                                ...variable,
                                name: event.target.value,
                            })
                        }
                    />
                </Stack>
                <Stack direction={'row'} width={1}>
                    <TextField
                        label={''}
                        fullWidth
                        value={variable.value}
                        onChange={(event: any) =>
                            updateVariable({
                                ...variable,
                                value: event.target.value,
                            })
                        }
                    />
                </Stack>
                <Stack direction={'row'} width={0.25} alignItems={'center'} justifyContent={'center'}>
                    <Checkbox
                        checked={variable.encrypted}
                        disabled={!variable.isNew}
                        onChange={(event: any) =>
                            updateVariable({
                                ...variable,
                                encrypted: event.target.checked,
                            })
                        }
                    />
                </Stack>
                <Box flexShrink={0}>
                    <IconButton
                        size={'small'}
                        onClick={() => {
                            deleteVariable(variable);
                        }}
                    >
                        <IconMi icon="delete" fontSize={'16'} />
                    </IconButton>
                </Box>
            </Stack>
            <Divider />
        </>
    );
}
